{
  "name": "ikp-frontends",
  "version": "berater-v1.8.0",
  "engines": {
    "npm": ">=10.0.0",
    "node": ">=20.19.0"
  },
  "projects": {
    "ikp": "apps/ikp",
    "ikp-berater": "apps/ikp-berater"
  },
  "browser": {
    "http": false,
    "https": false,
    "url": false,
    "path": false,
    "fs": false,
    "util": false,
    "node:os": false,
    "node:util": false,
    "node:http": false,
    "node:https": false,
    "node:url": false
  },
  "scripts": {
    "ng": "nx",
    "reset": "nx reset",
    "start": "nx serve",
    "start:expose-host": "nx serve --host 0.0.0.0",
    "ikp": "pnpm nx run ikp:serve:local",
    "berater": "pnpm nx run ikp-berater:serve:local",
    "messages": "pnpm nx run messages-control:serve:devtest",
    "devInt": "pnpm nx run meinewe:serve:devint",
    "build": "pnpm nx build",
    "test": "pnpm nx run-many --target=test --all",
    "analyze": "ng build --prod --stats-json && webpack-bundle-analyzer dist/ikp/stats.json",
    "full-test": "pnpm run test && pnpm nx run-many --target=e2e --all",
    "prepare": "husky",
    "newrelic:local": "SET NODE_ENV=development && node ",
    "newrelic:local:linux": "export NODE_ENV=development && node ",
    "storybook": "nx storybook storybook",
    "parse-version": "node parse-version.js"
  },
  "private": true,
  "dependencies": {
    "@aarsteinmedia/dotlottie-player-light": "^6.0.0",
    "@angular/animations": "20.1.7",
    "@angular/cdk": "20.1.6",
    "@angular/common": "20.1.7",
    "@angular/compiler": "20.1.7",
    "@angular/core": "20.1.7",
    "@angular/forms": "20.1.7",
    "@angular/localize": "20.1.7",
    "@angular/platform-browser": "20.1.7",
    "@angular/platform-browser-dynamic": "20.1.7",
    "@angular/router": "20.1.7",
    "@azure/msal-angular": "^4.0.18",
    "@azure/msal-browser": "^4.20.0",
    "@editorjs/editorjs": "^2.30.8",
    "@editorjs/list": "^2.0.8",
    "@editorjs/paragraph": "^2.11.7",
    "@fortawesome/fontawesome-free": "6.7.2",
    "@fortawesome/fontawesome-pro": "6.7.2",
    "@fortawesome/fontawesome-svg-core": "6.7.2",
    "@fortawesome/free-solid-svg-icons": "6.7.2",
    "@ng-bootstrap/ng-bootstrap": "19.0.1",
    "@ngrx/operators": "^20.0.1",
    "@ngrx/signals": "20.0.0",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "@nx/angular": "^21.1.8",
    "@popperjs/core": "^2.11.8",
    "@wienenergiegithub/modules-next": "4.87.6",
    "@wienenergiegithub/we-t1-bootstrap-theme": "2.10.1",
    "angular-oauth2-oidc": "^20.0.2",
    "baseline-browser-mapping": "^2.8.4",
    "bootstrap": "^5.3.6",
    "buffer": "^6.0.3",
    "chart.js": "^4.4.9",
    "chartjs-plugin-annotation": "^3.1.0",
    "data-forge": "^1.10.4",
    "dayjs": "^1.11.13",
    "editorjs-drag-drop": "^1.1.16",
    "editorjs-header-with-anchor": "^2.6.0",
    "esbuild": "^0.25.5",
    "js-cookie": "^3.0.5",
    "keycloak-angular": "^20.0.0",
    "keycloak-js": "^25.0.6",
    "ng2-charts": "^8.0.0",
    "ngx-webstorage": "20.0.0",
    "qrious": "^4.0.2",
    "rxjs": "7.8.2",
    "short-unique-id": "^5.3.2",
    "my-ua-parser": "^2.0.4",
    "storybook": "9.2.0-alpha.3",
    "swiper": "^11.2.8",
    "tslib": "^2.8.1",
    "uuid": "^11.1.0",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-architects/ngrx-toolkit": "^20.4.0",
    "@angular-devkit/build-angular": "20.1.6",
    "@angular-devkit/core": "20.1.6",
    "@angular-devkit/schematics": "20.1.6",
    "@angular-eslint/builder": "20.1.1",
    "@angular-eslint/eslint-plugin": "20.1.1",
    "@angular-eslint/eslint-plugin-template": "20.1.1",
    "@angular-eslint/schematics": "20.1.1",
    "@angular-eslint/template-parser": "20.1.1",
    "@angular-eslint/utils": "20.1.1",
    "@angular/cli": "~20.1.6",
    "@angular/compiler-cli": "20.1.7",
    "@angular/language-service": "20.1.7",
    "@chromatic-com/storybook": "^5.0.0-next.1",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "~9.33.0",
    "@etchteam/storybook-addon-status": "^7.0.1",
    "@nx/angular": "21.4.0",
    "@nx/cypress": "21.4.0",
    "@nx/eslint": "21.4.0",
    "@nx/eslint-plugin": "21.4.0",
    "@nx/jest": "21.4.0",
    "@nx/js": "21.4.0",
    "@nx/plugin": "21.4.0",
    "@nx/storybook": "21.4.0",
    "@nx/web": "21.4.0",
    "@nx/workspace": "21.4.0",
    "@schematics/angular": "20.1.6",
    "@storybook/addon-a11y": "9.2.0-alpha.3",
    "@storybook/addon-docs": "9.2.0-alpha.3",
    "@storybook/angular": "9.2.0-alpha.3",
    "@storybook/builder-webpack5": "9.2.0-alpha.3",
    "@storybook/test-runner": "0.24.0-next.1",
    "@swc-node/register": "1.11.1",
    "@swc/core": "1.13.3",
    "@swc/helpers": "^0.5.17",
    "@types/jest": "30.0.0",
    "@types/js-cookie": "^3.0.6",
    "@types/node": "24.3.0",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^8.46.0",
    "@typescript-eslint/utils": "8.39.1",
    "angular-eslint": "^20.1.1",
    "command-line-args": "^6.0.1",
    "cypress": "14.5.4",
    "default-composer": "^0.6.0",
    "esbuild": "^0.25.9",
    "esbuild-plugin-copy": "^2.1.1",
    "esbuild-plugin-json-merge": "^0.1.0",
    "eslint": "9.33.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-cypress": "5.1.1",
    "eslint-plugin-import": "2.x",
    "eslint-plugin-json": "^4.0.1",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-sonarjs": "^3.0.4",
    "eslint-plugin-storybook": "9.2.0-alpha.3",
    "eslint-plugin-unused-imports": "^4.1.4",
    "globals": "^16.2.0",
    "husky": "^9.1.7",
    "jasmine-core": "5.9.0",
    "jasmine-spec-reporter": "7.0.0",
    "jest": "30.0.5",
    "jest-canvas-mock": "^2.5.2",
    "jest-environment-jsdom": "30.0.5",
    "jest-fail-on-console": "^3.3.1",
    "jest-jasmine2": "30.0.5",
    "jest-junit": "^16.0.0",
    "jest-preset-angular": "15.0.0",
    "jest-sonar-reporter": "^2.0.0",
    "jest-util": "30.0.5",
    "jsonc-eslint-parser": "^2.4.0",
    "lint-staged": "^16.1.5",
    "merge-jsons-webpack-plugin": "^2.0.1",
    "mockdate": "^3.0.5",
    "ng-mocks": "^14.13.5",
    "ng-packagr": "^20.1.0",
    "nx": "21.4.0",
    "object-code": "^1.3.3",
    "prettier": "^3.5.3",
    "selenium-webdriver": "^4.35.0",
    "sonar-scanner": "^3.1.0",
    "storybook-addon-designs": "^6.3.1",
    "storybook-addon-mock": "^6.0.1",
    "ts-jest": "29.4.1",
    "ts-node": "10.9.2",
    "typescript": "5.8.3",
    "typescript-eslint": "^8.39.1"
  },
  "pnpm": {
    "overrides": {
      "koa@<3.0.3": ">=3.0.3",
      "tmp@<0.2.4": ">=0.2.4",
      "axios@<1.12.0": ">=1.12.0",
      "vite@<7.1.11": ">=7.1.11"
    }
  },
  "jestSonar": {
    "reportPath": "target/test-results/jest",
    "reportFile": "TESTS-results-sonar.xml"
  }
}
